// // plugins/mailchimp.client.js
// export default defineNuxtPlugin(() => {
//   // The '.client.js' suffix ensures this only runs on the client side
//   console.log("Mailchimp client plugin loaded");
//   const scriptId = "mcjs";
//   if (!document.getElementById(scriptId)) {
//     (function (c, h, i, m, p) {
//       m = c.createElement(h);
//       p = c.getElementsByTagName(h)[0];
//       m.async = 1;
//       m.src = i;
//       m.id = scriptId; // Add an ID to potentially check later
//       p.parentNode.insertBefore(m, p);
//     })(
//       document,
//       "script",
//       "https://chimpstatic.com/mcjs-connected/js/users/40d720045ed48c482401b9654/494b28afe2cd550e6c2af8628.js"
//     );
//   }
// });
